export const portalUser = {
    userId: null,
    roleId: null,
    role: null,
    ut_level: null,
    level: null,
    login: null,
    username: null,
    userFirstName: null,
    userLastName: null,
    enterpriseId: null,
    projectId: null,
    cardUid: null,
    timezone: null,
    locale: null
};

export default { portalUser };
